const COMPLETED = "ARTIFACT_PUBLICATION_STATE_COMPLETED";
const GENERAL = "ARTIFACT_AUDIENCE_KIND_GENERAL";
const MANUAL = "ARTIFACT_WAVE_MODE_MANUAL";
const ROLLING = "ARTIFACT_PUBLICATION_STATE_ROLLING";

export function waveProgress(row) {
    const lanes = [...(row.activeLanes ?? [])].sort((left, right) =>
        left.laneKey.localeCompare(right.laneKey) || left.rolloutId.localeCompare(right.rolloutId),
    );
    const rolloutIds = new Set(row.rolloutIds ?? []);
    const finalWave = Number(row.finalWavePosition ?? 0);
    const complete = row.publicationState === COMPLETED && !lanes.length && !row.activeLanesTruncated;
    const currentWave = lanes.length ? Math.min(...lanes.map((lane) => Number(lane.wavePosition))) : 0;
    const known = !row.activeLanesTruncated && Number.isInteger(finalWave) && finalWave > 0
        && lanes.length > 0 && new Set(lanes.map((lane) => lane.rolloutId)).size === lanes.length
        && lanes.every((lane) => rolloutIds.has(lane.rolloutId)
            && Number.isInteger(Number(lane.wavePosition)) && Number(lane.wavePosition) > 0
            && Number(lane.wavePosition) <= finalWave);
    return {
        complete,
        currentWave,
        finalWave,
        known,
        lanes,
    };
}

export function waveAdvanceCommands(row) {
    const progress = waveProgress(row);
    if (!progress.known || row.audienceKind === GENERAL || row.systemEnforced
        || row.publicationState !== ROLLING || row.waveMode !== MANUAL
        || row.held || row.holdClearPending || progress.lanes.some((lane) => lane.held)) return [];
    // Lanes already ahead wait, including after a partially successful batch.
    return progress.lanes.filter((lane) => Number(lane.wavePosition) === progress.currentWave)
        .map(({ rolloutId }) => ({ rolloutId }));
}
